import { useQuery } from '@apollo/client';

import type {
  CurrentAdvertiserContext,
  GetUserListQuery,
  GetUserListQueryVariables,
} from 'src/graphql/generated';
import { useAccountContext } from 'src/hooks/use-account-context';
import type { UseQueryResponse } from 'src/types/types';

import { USER_LIST_QUERY } from '../graphql/gql_queries';

export const useUserList = (): UseQueryResponse<
  GetUserListQuery | undefined
> => {
  const { data: accountData } = useAccountContext();
  const currentAdvertiser = accountData?.currentAdvertiser as
    | CurrentAdvertiserContext
    | undefined;

  const { data, loading, error } = useQuery<
    GetUserListQuery,
    GetUserListQueryVariables
  >(USER_LIST_QUERY, {
    skip: !currentAdvertiser?.seekId,
  });

  return { loading, error, data };
};
